import {getMediaImageFormatForContentType} from '@app/web-player/media-image/media-image';

export function normalizeAlbumTypeKey(slug: string): string {
  return slug.trim().toLowerCase().replace(/-/g, '_');
}

export function getContentAvailabilityKey(slug: string): string {
  const key = normalizeAlbumTypeKey(slug);
  if (key === 'audio_book') {
    return 'audiobook';
  }
  if (key === 'video_podcast') {
    return 'podcast_video';
  }
  return key;
}

export function getAlbumTypeLabel(
  slug: string,
  options?: {musicLabel?: string},
): string {
  const key = normalizeAlbumTypeKey(slug);
  const labels: Record<string, string> = {
    music: options?.musicLabel ?? 'Music',
    music_video: 'Music videos',
    podcast: 'Podcasts',
    video_podcast: 'Video podcasts',
    podcast_video: 'Video podcasts',
    audiobook: 'Audiobooks',
    audio_book: 'Audiobooks',
  };

  return labels[key] ?? toTitleCase(slug);
}

export function getAlbumTypeRoute(slug: string): string {
  const key = normalizeAlbumTypeKey(slug);
  return key === 'music' ? '/library/albums' : `/library/albums/${slug}`;
}

export function getAlbumTypeContentFormat(
  slug: string,
): 'landscape' | 'poster' | 'portrait' | undefined {
  const format = getMediaImageFormatForContentType(slug);

  return format === 'square' ? undefined : format;
}

export function getAlbumTypeSortIndex(slug: string): number {
  const key = normalizeAlbumTypeKey(slug);
  const order = [
    'music',
    'music_video',
    'podcast',
    'video_podcast',
    'podcast_video',
    'audiobook',
    'audio_book',
  ];
  const index = order.indexOf(key);
  return index === -1 ? order.length : index;
}

function toTitleCase(value: string): string {
  return value
    .replace(/[-_]/g, ' ')
    .replace(/\b\w/g, match => match.toUpperCase());
}
